export const handleAlphaNumeric = (e) => {
  const regex = /[^a-zA-Z0-9 ]/g;
  e.target.value = e.target.value.replace(regex, "");
};

export const handleUuid = (e) => {
  // single instances of / or -, and prevent multiple consecutive / or -
  const regex = /[^a-zA-Z0-9 /-]|([/-])\1+/g;
  e.target.value = e.target.value.replace(regex, "");
};
